// The two simulators the league runs today, with their stable database ids. There is no public
// "list simulators" endpoint (only an admin one), so the ids are fixed here rather than fetched —
// same approach the Drivers page already takes with its two hardcoded simulator toggle buttons.
export const SIMULATORS = [
  { id: 2, name: "iRacing" },
  { id: 1, name: "EA F1" },
];
